// `/voice/relances` legacy redirect — D-Wave Batch 4 D25 (Q4).
//
// Relances was historically nested under the voice surface. With D25 the
// follow-ups queue is a top-level sidebar slot at `/relances`. This route
// preserves legacy deeplinks (saved bookmarks, doc links) by hard-redirecting
// `/voice/relances` → `/relances/pending`.

import { createRoute, redirect } from '@tanstack/react-router';

import { Route as AuthedLayoutRoute } from '../__layout';

export const Route = createRoute({
  getParentRoute: () => AuthedLayoutRoute,
  path: 'voice/relances',
  beforeLoad: () => {
    throw redirect({ to: '/relances/pending' });
  },
  component: () => null,
});
